// ======================================================================
// File Name       : user
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { SELECT_TARGET_DATA } from '../../constants';

export function postUserGetList(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'user/GetList',
    data: { ...PARAM_DEFAULT, ...data },
  });
}

export function postUserEdit(data) {
  return commonCallApi({
    path: 'user/Edit',
    data: { ...data },
  });
}

export function getUserAuthorityList() {
  const param = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  return commonCallApi({
    path: 'userAuthority/GetList',
    data: param,
  });
}

export function postUserGroupRelationGetList(data) {
  const param = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  return commonCallApi({
    path: 'userGroupRelation/GetList',
    data: { ...param, ...data },
  });
}

export function getGroupCourseRelation(data) {
  const param = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  return commonCallApi({
    path: 'groupCourseRelation/GetList',
    data: { ...param, ...data },
  });
}

export function getGroupList() {
  const param = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  return commonCallApi({
    path: 'group/GetStructure',
    data: { ...param },
  });
}

// Step 9.0.1 START
export function postSendAccountInfo(data) {
  return commonCallApi({
    path: 'user/SendAccountInfo',
    data: { ...data },
  });
}
// Step 9.0.1 END
